import fetchWrapper from "./fetchWrapper";
import { deliveryCosts } from "./types/deliveryCosts";
import { isFetchWrapperError } from "./errorCheckers";

export default async function fetchDeliveryCosts(address: any): Promise<any> {
    if (!address || !address.country || !address.postalCode) return null
    const deliveryCostsRequest: Promise<deliveryCosts | null | { code: number }> = fetchWrapper('/api/deliveryCosts', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(address)
    })
    const deliveryCosts: deliveryCosts | null | { code: number } = await deliveryCostsRequest
    if (!deliveryCosts || isFetchWrapperError(deliveryCosts)) return null

    return deliveryCosts
};